export default __webpack_public_path__ + "static/media/early-funding.3e824e48.svg";